<script>
import UserAvatar from '@components/user/user-avatar.vue'
import baseMixin from '@/mixins/baseMixin'
import { mapGetters } from 'vuex'

export default {
  name: 'TheSettingsProfileCard',
  components: { UserAvatar },
  mixins: [baseMixin],
  computed: {
    ...mapGetters({
      user: 'auth/currentUser',
      userFullName: 'auth/currentUserFullName',
      userEmail: 'auth/currentUserEmail',
      isLoggedIn: 'auth/isUserLoggedIn',
    }),
  },
}
</script>

<template>
  <div id="profile" class="settings-card settings-card--profile">
    <p
      :class="['body-2 settings-card__heading']"
      v-text="$t('settings.profileSectionTitle')"
    ></p>

    <v-card class="pt-0 pb-0 my-0 rounded-xl custom-elevation overflow-hidden">
      <v-card-text>
        <div class="d-flex align-center">
          <UserAvatar
            v-if="isLoggedIn"
            :badge-icon="isImpersonating ? 'mdi-incognito' : ''"
            badge-color="blue"
            :badge="isImpersonating"
            badge-offset-x="20"
            badge-offset-y="20"
            :name="userFullName"
            class="mr-4"
            size="md"
          />

          <div class="d-flex flex-column">
            <span
              id="profile-full-name"
              :class="['subtitle-2 settings-card__label font-weight-medium']"
              v-text="userFullName"
            >
            </span>
            <span
              id="profile-email"
              :class="['caption settings-card__label']"
              v-text="userEmail"
            >
            </span>
          </div>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-list class="py-0">
        <!-- Change Password -->
        <v-list-item
          id="settings-card-list-item--change-password-link"
          link
          :to="{ name: 'changePassword' }"
        >
          <v-list-item-avatar>
            <v-icon>mdi-key</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <span
              :class="['caption settings-card__label']"
              v-text="$t('settings.profileChangePassword')"
            >
            </span>
          </v-list-item-content>

          <v-list-item-action>
            <v-icon>mdi-menu-right</v-icon>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card>
  </div>
</template>
